import React, { FunctionComponent, ReactNode } from 'react';
import * as styles from './ListItemRenderer.style';

export interface ListItemRendererProps {
  children: ReactNode,
}

const ListItemRenderer: FunctionComponent<ListItemRendererProps> = ({
  children,
}) => (
  <li css={styles.item}>
    {children}
  </li>
);

export default ListItemRenderer;
